// import { constants } from "../helpers/constants";
import { helperConstants as constants } from "../helpers/helperConstants";
import { useNetwork } from "wagmi";
import { useEffect, useState } from "react";
import { getCoinGeckoId } from "../helpers/getChainName";
import useGetUSDPriceOfToken from "./useGetUSDPriceOfToken";
import { BigNumber } from "ethers";
import { useSwitchNetworkWrapper } from "../components/Web3WalletProvider";

export default function useGetTokenPrice(chainId: string, tokenName?: string) {
  const { chains, switchNetwork } = useSwitchNetworkWrapper();
  const [currentChainId, setCurrentChainId] = useState(null);
  const { chain } = useNetwork();
  const usdPrice = Object.values(
    useGetUSDPriceOfToken(getCoinGeckoId(tokenName ?? chainId), 1)?.data || {}
    // @ts-ignore
  )?.[0]?.usd;

  useEffect(() => {
    try {
      chain && setCurrentChainId(BigNumber.from(chain.id)._hex);

      const chainIdNumber = Number(chainId);

      const isSupportedChain = chains.some((c) => c.id === chainIdNumber);

      if (chain && !isSupportedChain) {
        switchNetwork(constants.helpers.chainId);
      }

      if (chain && isSupportedChain && chain.id != chainIdNumber) {
        switchNetwork(chains.find((c) => c.id === chainIdNumber).id);
      }

      return () => {
        setCurrentChainId(null);
      };
    } catch (e) {
      console.error(e);
    }
  }, [chain, chains]);

  return {
    usdPrice,
    currentChainId,
  };
}
